//const FormatCurrency=(price=0)=>{
const FormateCurrency=(price=0)=>{
    if(price===undefined)return
    if(price<1 && price>8e-10){
        price=(0.00001<price?price.toFixed(5):price.toFixed(7))
        return `$${price}`
    }
    return price.toLocaleString('en-US',{
        style:'currency',
        currency:'USD',
    })
}

/** Whole dollars — used on mobile tables to save horizontal space. */
export const formatCurrencyCompact = (price = 0) => {
    if (price === undefined || price === null) return;
    const num = Number(price);
    if (!Number.isFinite(num)) return;
    if (num < 1 && num > 8e-10) {
        const trimmed = 0.00001 < num ? num.toFixed(5) : num.toFixed(7);
        return `$${trimmed}`;
    }
    return num.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });
};

export default FormateCurrency;